import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/home/HomePage";
import NotFoundPage from "../pages/error/NotFoundPage";
import AnatomyPage from "../pages/anatomy/AnatomyPage";
import SymptomPage from "../pages/symptom/SymptomPage";
import Layout from "../layouts/Layout";
import CustomerLayout from "../layouts/CustomerLayout";
import ThreeDmodel from "../features/home/ThreeDmodel";
import Appointment from "../pages/Appointment/Appointment";
import AppointmentPrintPage from "../pages/Appointment/AppointmentPrintPage";

const AppRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="*" element={<NotFoundPage />} />

        <Route element={<Layout />}>
        <Route path="/appointment" element={<Appointment />} /> 
          <Route path="/" element={<HomePage />} />
          <Route path="/anatomy" element={<AnatomyPage />} />
          <Route path="/symptoms" element={<SymptomPage />} />
          <Route path="/threeDmodel" element={<ThreeDmodel />} />
          <Route path="/appointment-print" element={<AppointmentPrintPage />} />

        </Route>

        <Route path="/customer/layouts" element={<CustomerLayout />} />

      </Routes>
    </>
  );
};

export default AppRoutes;
